function Learning() {
    return (
        <div>Learning Page</div>
    )
}

export default Learning;